import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateCarePlanIcd10Codes } from '../types';

const onCreateCarePlanIcd10Codes: IThunkCreateCarePlanIcd10Codes = thunk(
  // @ts-ignore
  async ({ addCarePlanIcd10Codes }, payload) => {
    const { patientId, data } = payload;
    const carePlanIcd10Codes = await api.carePlanIcd10Codes
      .create(patientId, data)
      .then(res => res.data);
    addCarePlanIcd10Codes(carePlanIcd10Codes);
  },
);

export default onCreateCarePlanIcd10Codes;
